export default __webpack_public_path__ + "static/media/fpb40004.084407d9.png";